import React from 'react';
import { SkeletonBlock } from '../../../components/skeleton/skeleton';

// Referral sayfasının ilk paint iskeleti: header + hero + 4 stat + tablo.
const ReferralSkeleton = () => (
  <div className="min-h-[calc(100vh-4rem)] bg-white px-4 py-6 dark:bg-slate-900/40 sm:px-6 lg:px-8 lg:py-8">
    <div className="mx-auto max-w-5xl space-y-6">
      <div className="space-y-2">
        <SkeletonBlock className="h-7 w-44" />
        <SkeletonBlock className="h-4 w-80 max-w-full" />
      </div>

      <SkeletonBlock className="h-44 w-full !rounded-xl" />

      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <SkeletonBlock key={i} className="h-28 w-full !rounded-md" />
        ))}
      </div>

      <SkeletonBlock className="h-10 w-56 !rounded-md" />

      <div className="overflow-hidden rounded-md border border-slate-200 dark:border-slate-700">
        <table className="w-full">
          <thead className="bg-slate-50 dark:bg-slate-800/70">
            <tr>
              {Array.from({ length: 6 }).map((_, i) => (
                <th key={i} className="px-4 py-3 text-left">
                  <SkeletonBlock className="h-3 w-16" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 6 }).map((_, r) => (
              <tr
                key={r}
                className="border-b border-slate-100 dark:border-slate-700/60"
              >
                {Array.from({ length: 6 }).map((_, c) => (
                  <td key={c} className="px-4 py-3">
                    <SkeletonBlock className="h-4 w-16" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default ReferralSkeleton;
